const swiperMultimedia = {
    swiperInstance: null,
    swiperInstancePagination: null,

    init: () => {
        const mediaMatch = window.matchMedia('(min-width: 769px)');

        import('swiper/bundle').then(({Swiper}) => {

            let domEl = document.getElementById('js-swiper-multimedia');
            let domElPagination = document.getElementById('js-swiper-multimedia-pagination');

            if (domEl && domElPagination) {
                const paginationParams = getSwiperPaginationParams();
                const params = getSwiperParams();

                swiperMultimedia.swiperInstancePagination = new Swiper(domElPagination, paginationParams);   //NOSONAR
                swiperMultimedia.swiperInstance = new Swiper(domEl, params);   //NOSONAR

                function slideOtherGalleryTo(sGalleryName, nSlideIndex) {
                    sGalleryName.slideTo(nSlideIndex);
                }

                function pauseVideo() {
                    // pause youtube iframe on slide change
                    jQuery(".plyr__video-wrapper iframe").each(function(){
                        // using enablejsapi=1 from the iframe to control the pause
                        this.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*')
                    })
                }

                setTimeout(function() {

                    // actions on slideChange of thumbs

                    if ((swiperMultimedia.swiperInstancePagination.slides.length) > 3 && mediaMatch.matches === true) {
                        // function to manage a layout like "centeredSlides: false" when "slidesPerView: > 1" but still using" centeredSlides: true"
                        swiperMultimedia.swiperInstancePagination.on('transitionStart', function () {
                            let translate = this.getTranslate();
                            let slidesPerView = this.params.slidesPerView === 'auto ' ?this.slidesPerViewDynamic() : this.params.slidesPerView;
                            if(this.slides.length<=slidesPerView){
                                return;
                            }

                            let y = 0;
                            let z = 0;
                            let x = 0;

                            if(this.activeIndex>1 && this.activeIndex > slidesPerView/2)
                            {
                                translate = this.activeIndex === this.slides.length -1 ? -this.snapGrid[this.snapGrid.length - 2] : this.translate;

                                if (this.isHorizontal()) {
                                    x = this.params.rtl ? -translate : translate;
                                } else {
                                    y = translate;
                                }

                                if (this.roundLengths) {
                                    x = Math.floor(x);
                                    y = Math.floor(y);
                                }
                            }else
                            {
                                y = 0;
                                z = 0;
                                x = 0;

                            }

                            if (this.support.transforms3d) { this.$wrapperEl.transform(("translate3d(" + x + "px, " + y + "px, " + z + "px)")); }
                            else { this.$wrapperEl.transform(("translate(" + x + "px, " + y + "px)")); }
                            // Move main Gallery to the selected image
                            slideOtherGalleryTo(swiperMultimedia.swiperInstance, this.activeIndex);
                            pauseVideo()
                        });
                    } else {
                        swiperMultimedia.swiperInstancePagination.on('transitionStart', function () {
                            let activeIndex = this.realIndex;
                            slideOtherGalleryTo(swiperMultimedia.swiperInstance, activeIndex);
                            pauseVideo()
                        });
                    }
                },250);

            }
        });
    }
};

const getSwiperPaginationParams = () => {
    return {
        watchOverflow: true,
        // set "centeredSlides: true" anyway
        centeredSlides: true,
        spaceBetween: 32,
        slidesPerView: 2,
        speed: 500,
        a11y: true,
        initialSlide: 1, // need to start from a slide != 0 to trigger the transition start and repositione the thumbs
        slideToClickedSlide: true,
        watchSlidesProgress: true,
        grabCursor: true,
        mousewheel: {
            forceToAxis: true
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            768: {
                slidesPerView: 3
            },
        },
        on: {
            // since we want the previous years on the left, we start with the last slide
            init: function () {
                setTimeout(function() {
                    // triggering the transition
                    swiperMultimedia.swiperInstancePagination.slidePrev(100, true);
                }, 500)
            }
        }
    };
};

const getSwiperParams = () => {

    return {
        watchOverflow: true,
        centeredSlides: true,
        spaceBetween: 0,
        slidesPerView: 1,
        speed: 500,
        effect: 'fade',
        resizeObserver: true,
        slideToClickedSlide: true,
        watchSlidesProgress: true,
        a11y: true,
        allowTouchMove: false, // preventing the touch slide
        thumbs: {
            swiper: swiperMultimedia.swiperInstancePagination,
        }
    }
}

export default swiperMultimedia;